export var DocumentService;
(function (DocumentService) {
    DocumentService["Pregnancy"] = "pregnancy";
    DocumentService["Manager"] = "manager";
    DocumentService["PrePostOp"] = "pre_post_op";
    DocumentService["Basic"] = "basic";
})(DocumentService || (DocumentService = {}));
export const DOCUMENT_SERVICE_FOR_HUMANS = {
    [DocumentService.Pregnancy]: "pregnantPackage",
    [DocumentService.Manager]: "managerPackage",
    [DocumentService.PrePostOp]: "surgeryPackage",
    [DocumentService.Basic]: "basicPackage",
};
